import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'antd';
import Card, { TitleCard } from '../../core/Card'
import Line from '../../core/Line'
import EmptyState from '../../core/components/EmptyState'
import { Icon, TripsIcon, BackIcon, FromToIcon, PlusIcon, CrownIcon, BriefcaseIcon, MarkerIcon, ForwardIcon, HomeIcon, DotIcon } from '../../core/icons'
import { Row, Col, } from 'antd';

const Trip = ({ onClick, trip}) =>
  <Line onClick={()=>onClick(trip.token_id)}>
    <Col span={2}>
      <Icon type={trip.purpose}/>
    </Col>
    <Col span={6}>
      {trip.purpose}
    </Col>
    <Col className="fromto" span={14}>
      {/* <FromToIcon/> */}
      <Row>
        <DotIcon color='#31B59F'/>
        {trip.from}
      </Row>
      <Row>
        <DotIcon color='#FF5166'/>
        {trip.to}
      </Row>
    </Col>
    <Col span={2}>
      <ForwardIcon/>
    </Col>
  </Line>

const All = ({trips, onClick}) =>
  <div className="All">
    <TitleCard sticky>
      <h1>Favorite Trips</h1>
      <Link to="/account/favorite-trips/new"><Button type="primary" icon="plus">New</Button></Link>
    </TitleCard>

    <Card>
      {trips.map((trip)=> Trip({trip, onClick}) )}
      {trips.length<1 &&
        <EmptyState
          title="No Favorite Trips yet."
          buttonLink="/account/favorite-trips/new"
          buttonText="Add a Favorite Trip"
          buttonIcon='plus'
          icon={TripsIcon}
          />
     }
    </Card>
  </div>

export default All



// WEBPACK FOOTER //
// ./src/account/favorite-trips/All.jsx